export default {
    "logo rock content": "Redirect to Home",
    home: "Enter the Home",
    "my account": "Enter on My Account",
    products: "Enter in Products",
    wallet: "Enter in Wallet",
    financial: "Enter in Financial",
};
